import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { OfficeEquipmentConditionDto } from '../../../models/equipment-model/office-equipment.model';
import { Division } from '../../../models/shared-component/division';
import { OrganizationModel } from '../../../models/shared-component/modal-response-model';
import { Organization } from '../../../models/shared-component/organization';
import { Subdivision } from '../../../models/shared-component/subdivision';
import { ShareService } from '../../../services/shared.service';

@Component({
  selector: 'app-organization-selector',
  templateUrl: './organization-selector.component.html',
  styleUrls: ['./organization-selector.component.scss']
})
export class OrganizationSelectorComponent implements OnInit {

  constructor(
    private sharedService: ShareService,
    private formBuilder: FormBuilder,
  ) { }

  @Input('defaultOrganizationId') defaultOrgId: number | undefined;
  @Input('defaultDivisionId') defaultDivisionId: number | undefined;
  @Input('defaultSubDivisionId') defaultSubDivisionId: number | undefined;
  @Input('showDetail') showDetail: boolean;
  @Output('output') output = new EventEmitter<OrganizationModel>();

  public form: FormGroup;
  organizations$ = new BehaviorSubject<Organization[] | null>(null);
  divisions$ = new BehaviorSubject<Division[] | null>(null);
  subdivisions$ = new BehaviorSubject<Subdivision[] | null>(null);
  selectOrganizaId: number;

  ngOnInit(): void {
    this.getOrganization();
    this.initialForm();

    if (this.defaultOrgId) {
      this.setDefaultValue();
    }
  }

  changeOrganize() {
    this.output.emit(this.form.getRawValue() as OrganizationModel);
  }

  initialForm() {
    this.form = this.formBuilder.group({
      organizationId: [null],
      divisionId: [null],
      subdivisionId: [null],
    });

    if (this.showDetail) {
      this.form.get('organizationId')?.disable();
      this.form.get('divisionId')?.disable();
      this.form.get('subdivisionId')?.disable();
    }
  }

  setDefaultValue() {
    if (this.defaultOrgId) {
      this.form.get('organizationId')?.setValue(this.defaultOrgId);
      this.getDivisions(this.defaultOrgId);
      if (this.defaultDivisionId) {
        this.getSubdivisions(this.defaultDivisionId);
        this.form.get('divisionId')?.setValue(this.defaultDivisionId);
        if (this.defaultSubDivisionId) {
          this.form.get('subdivisionId')?.setValue(this.defaultSubDivisionId);
        }
      }
    }

    if (this.showDetail) {
      this.form.get('organizationId')?.disable();
      this.form.get('divisionId')?.disable();
      this.form.get('subdivisionId')?.disable();
    }
  }

  async getOrganization(): Promise<void> {
    this.organizations$.next(await firstValueFrom(this.sharedService.getOrganizations()));
  }

  async getDivisions(organizationId: number): Promise<void> {
    this.divisions$.next(null);
    this.subdivisions$.next(null);
    this.form.get('divisionId')?.enable();
    this.form.get('divisionId')?.setValue(null);
    this.form.get('subdivisionId')?.setValue(null);
    const response = await firstValueFrom(
      this.sharedService.getDivisions(organizationId)
    );
    this.divisions$.next(response);
    this.changeOrganize();
  }

  async getSubdivisions(divisionId: number): Promise<void> {
    this.subdivisions$.next(null);
    this.form.get('subdivisionId')?.setValue(null);
    this.form.get('subdivisionId')?.enable();
    const response = await firstValueFrom(
      this.sharedService.getSubdivisions(divisionId)
    );
    this.subdivisions$.next(response);
    this.changeOrganize();
  }

}
